"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityArchiveReasons = exports.FundingOpportunityArchiveReason = exports.Product = exports.FundingOpportunityStatus = void 0;
var FundingOpportunityStatus;
(function (FundingOpportunityStatus) {
    FundingOpportunityStatus["ACTIVE"] = "active";
    FundingOpportunityStatus["ARCHIVED"] = "archived";
    FundingOpportunityStatus["INTERESTED"] = "interested";
})(FundingOpportunityStatus = exports.FundingOpportunityStatus || (exports.FundingOpportunityStatus = {}));
var Product;
(function (Product) {
    Product["SMARTRAISE"] = "smartraise";
    Product["SMARTMATCH"] = "smartmatch";
    Product["NONE"] = "none";
})(Product = exports.Product || (exports.Product = {}));
var FundingOpportunityArchiveReason;
(function (FundingOpportunityArchiveReason) {
    FundingOpportunityArchiveReason["COMPANY_NOT_INTERESTED"] = "company_not_interested";
    FundingOpportunityArchiveReason["FAILED_DUE_DILIGENCE"] = "failed_due_diligence";
    FundingOpportunityArchiveReason["INVESTOR_NOT_INTERESTED"] = "investor_not_interested";
    FundingOpportunityArchiveReason["SUCCESSFULLY_FUNDED"] = "successfully_funded";
    FundingOpportunityArchiveReason["OTHER"] = "other";
})(FundingOpportunityArchiveReason = exports.FundingOpportunityArchiveReason || (exports.FundingOpportunityArchiveReason = {}));
exports.OpportunityArchiveReasons = {
    [FundingOpportunityArchiveReason.COMPANY_NOT_INTERESTED]: 'Company not interested',
    [FundingOpportunityArchiveReason.FAILED_DUE_DILIGENCE]: 'Failed due diligence',
    [FundingOpportunityArchiveReason.INVESTOR_NOT_INTERESTED]: 'Investor not interested',
    [FundingOpportunityArchiveReason.SUCCESSFULLY_FUNDED]: 'Successfully funded',
    [FundingOpportunityArchiveReason.OTHER]: 'Other',
};
//# sourceMappingURL=enums.js.map